import { createSlice } from '@reduxjs/toolkit';

const navbarSlice = createSlice({
  name: 'navbar',
  initialState: {
    foldedOpen: false,
    mobileOpen: false,
  },
  reducers: {
    navbarToggleFolded: state => {
      state.foldedOpen = !state.foldedOpen;
    },
    navbarOpenFolded: state => {
      state.foldedOpen = true;
    },
    navbarCloseFolded: state => {
      state.foldedOpen = false;
    },
    navbarToggleMobile: state => {
      state.mobileOpen = !state.mobileOpen;
    },
    navbarOpenMobile: state => {
      state.mobileOpen = true;
    },
    navbarCloseMobile: state => {
      state.mobileOpen = false;
    },
  },
});

export const {
  navbarToggleFolded,
  navbarOpenFolded,
  navbarCloseFolded,
  navbarToggleMobile,
  navbarOpenMobile,
  navbarCloseMobile,
} = navbarSlice.actions;

export default navbarSlice.reducer;
